import { render, staticRenderFns } from "./MainLanding.vue?vue&type=template&id=5a3053d8&scoped=true"
import script from "./MainLanding.vue?vue&type=script&lang=js"
export * from "./MainLanding.vue?vue&type=script&lang=js"
import style0 from "./MainLanding.vue?vue&type=style&index=0&id=5a3053d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3053d8",
  null
  
)

export default component.exports